// import { LoyaltyRepository, TrainingsGroupRepository } from 'api/repository';
import { Box, DesktopItem, LoaderForm } from 'components';
import React, { ReactElement, useEffect } from 'react';

import './trainings.scss';
import { useTranslation } from 'react-i18next';
import { useUser } from 'store/userContext';
import { TrainingsRepository } from 'api/repository';
import useCheckColor from 'store/hooks/useCheckColor';

const Panel = (): ReactElement => {
  const { t } = useTranslation('employee');

  const { userId, hydrated } = useUser();

  const [getTrainings, dataTrainings] = TrainingsRepository.useGetTrainings();

  useEffect(() => {
    if (userId && userId !== null) {
      getTrainings({ userId });
    }
  }, [userId]);

  //   START Color

  const checkColor = useCheckColor();

  // END Color

  return (
    <LoaderForm active={dataTrainings === undefined} type="getData">
      <>
        <Box
          id="userTrainingsDesktop"
          name={t(`userTrainingsDesktop.trainings`)}
          svgIcon="desktop"
          noContentStyle
        >
          {dataTrainings &&
          dataTrainings !== null &&
          Object.keys(dataTrainings)?.length > 0
            ? Object.keys(dataTrainings)?.map((k) => (
                <Box
                  id="userTrainingBox"
                  name={k}
                  noMarginBottom
                  noShadow
                  noPadding
                  noRadius
                  lightHeader
                >
                  <div className="userTrainingContent">
                    {Object.keys(dataTrainings?.[k]).map((kk) => (
                      <DesktopItem
                        id="trainings"
                        name={`${dataTrainings?.[k]?.[kk]?.training?.name}  ${
                          dataTrainings?.[k]?.[kk]?.supplement &&
                          dataTrainings?.[k]?.[kk]?.supplement !== ''
                            ? ` - ${dataTrainings?.[k]?.[kk]?.supplement}`
                            : ''
                        }`}
                      >
                        <>
                          {dataTrainings?.[k]?.[kk]?.trainingDate !== null ? (
                            <div className="trainingDetailBox">
                              <div className="traininglLabel">
                                {t(`userTrainingsDesktop.trainingsDate`)}
                              </div>
                              <div className="trainingValue">
                                {dataTrainings?.[k]?.[kk]?.trainingDate}
                              </div>
                            </div>
                          ) : (
                            ''
                          )}
                          {dataTrainings?.[k]?.[kk]?.expirationTrainingDate !==
                          null ? (
                            <div
                              className={`dateTrainingBox ${checkColor(
                                dataTrainings?.[k]?.[kk]
                                  ?.expirationTrainingDate,
                                'pracownik',
                                'szkoleniaBHP'
                              )}`}
                            >
                              <div
                                className={`dateTrainingLabel ${checkColor(
                                  dataTrainings?.[k]?.[kk]
                                    ?.expirationTrainingDate,
                                  'pracownik',
                                  'szkoleniaBHP'
                                )}`}
                              >
                                {t(
                                  `userTrainingsDesktop.expirationTrainingDate`
                                )}
                              </div>
                              <div
                                className={`dateTrainingValue ${checkColor(
                                  dataTrainings?.[k]?.[kk]
                                    ?.expirationTrainingDate,
                                  'pracownik',
                                  'szkoleniaBHP'
                                )}`}
                              >
                                {
                                  dataTrainings?.[k]?.[kk]
                                    ?.expirationTrainingDate
                                }
                              </div>
                            </div>
                          ) : (
                            ''
                          )}

                          <div className="borderTop" />
                        </>
                      </DesktopItem>
                    ))}
                  </div>
                </Box>
              ))
            : null}
          {dataTrainings === null ||
          (dataTrainings && Object.keys(dataTrainings).length === 0) ? (
            <div className="noTrainings">Brak szkoleń</div>
          ) : (
            <></>
          )}
        </Box>
      </>
    </LoaderForm>
  );
};

export default Panel;
